export var InstallLocation;
(function (InstallLocation) {
    InstallLocation["Profile"] = "profile";
    InstallLocation["Settings"] = "settings";
    InstallLocation["Standalone"] = "standalone";
    InstallLocation["Lightbox"] = "lightbox";
})(InstallLocation || (InstallLocation = {}));
//# sourceMappingURL=types.js.map